<template>
	<div class="attach-object">
		<select v-model.number="value.srcType" :disabled="ro">
			<option v-for="type in enabledTypeList" :value="type.value">{{type.name}}</option>
		</select>
		<span v-if="showSuggest && value.srcType>-1" style="padding-left: 10px;">
			<suggester-part :part="suggest" :data="value" :readonly="ro" :class="[clazz, errorClass]" />
		</span>
	</div>	
</template>
<script setup lang="ts">
	import type {ListItem} from "@t/list/List";
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import SuggesterPart from "@fd/editors/suggester/SuggesterPart.vue";
	import {ref, computed, watch, nextTick, onMounted} from 'vue';
	import {injectEnv} from "@fd/Environment";
	import type {TypeAttach} from "@t/fd/editor/TypeAttach";
	import useEditor, {type EditorProps, editorProps} from "@fd/editors/Editor";
	
	const uprops = defineProps({...editorProps});
	const props = uprops as EditorProps;
	const attachProps: TypeAttach = props.part as TypeAttach;
	const {visible, value, clazz, style, ro, errors, errorClass} = useEditor(props);
	
	const env = injectEnv();
	const showSuggest = ref(true);
	
	const attachSuggester = computed<string>(() => {
			//console.log("typeList:"+JSON.stringify(typeList));
			const found = enabledTypeList.value.find((item) => parseInt(item.value)===value.value.srcType);
			if (found)  {
				//console.log("found:"+found.spec);
				return found.spec;
			}
			else return "";
	});
	
	const enabledTypeList = computed<string>(() => {
			const typeList: ListItem[] = attachProps.typeList;
			if (attachProps.enabledTypes && attachProps.enabledTypes.length>0) {
				//console.log("filter by:"+JSON.stringify(attachProps.enabledTypes));
				return  typeList.filter((item) => parseInt(item.value)===-1 || attachProps.enabledTypes.includes(parseInt(item.value)));
			}
			else {
				return typeList;
			}
	});
	
	const suggest = computed(() => {		
		return {
			type: "suggest",
			property: "srcId",
			url: "suggestfeed.do",
			suggester: attachSuggester.value,
			minTags: 0,
			maxTags: 1,
			srcType: value.value.srcType,
			propagate: [
				{
					d: "srcId",
					s: "id.main",
					empty: "0"
				},
				{
					d: "srcName",
					s: "title.main",
					empty: ""
				}
			],
			tag: [
				{
					d: "srcId",
					t: "id",
					empty: "0"
				},
				{
					d: "srcName",
					t: "name",
					empty: ""
				}
			]
		};
	});
	
	watch(() => value.value.srcType, (srcType) => {
		//console.log(`changing srcType: ${srcType}`);
		value.value.srcId="";
		value.value.srcName="";
		if (srcType!==-1) {
			reloadSuggest();
		}
	  });
	
	function reloadSuggest(): void {
		showSuggest.value=false;
		nextTick(() => {
			showSuggest.value=true;
		});
	}
	
	/*onMounted(() => {
		console.dir(props.data);
	});*/
</script>
